import * as React from "react";
import { forwardRef } from "react";
const SvgPenOutline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 23L4.63 22.3867L21.3433 5.66667L22.0133 6.33667L15.7867 12.5667L16.79 13.57L24 6.35667L18.6433 1L0.946667 18.7033L0 23ZM3.95333 21.0533L1.63667 21.36L2.27667 19.38L11.78 9.87333L13.4533 11.5467L3.95 21.0533H3.95333ZM14.44 10.5633L12.7667 8.89L18.6667 2.99L20.34 4.66333L14.44 10.5633Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPenOutline);
export { ForwardRef as ReactComponent };
